/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { BroadcastService } from './broadcast.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'broadcast',
  templateUrl: './broadcast.component.html',
  styleUrls: ['./broadcast.component.scss']
})
export class BroadcastComponent implements OnInit, OnDestroy {
  @Output() openDrawer = new EventEmitter<any>();
  myBroadcast: Array<any> = [];
  broadcastCount: number;
  newBroadcastSubscription: Subscription;

  constructor(
    private dataCollectorService: DataCollectorService,
    public utilityService: UtilityService,
    private broadcastService: BroadcastService
  ) { }

  ngOnInit(): void {
    this.getBroadcastMessages();
    this.newBroadcastSubscription = this.broadcastService.newMessageBroadcasted.subscribe((res: boolean)=>{
      if(res){
        this.getBroadcastMessages();
      }
    });
  }

  getBroadcastMessages(): void{
    this.broadcastService.getBroadcastMessages().then((brodcastData: any) => {
      this.myBroadcast = brodcastData || [];
      this.broadcastCount = brodcastData?.length || 0;
    })
  }

  openBroadcastDrawer(): void{
    this.openDrawer.emit({data:this.myBroadcast, count: this.broadcastCount});
  }

  ngOnDestroy(): void {
    this.newBroadcastSubscription?.unsubscribe();
  }
}
